export default __webpack_public_path__ + "static/media/alertRed.a9c207f4.svg";